(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-about-designer"] && !Shopify.designMode) return;
  try {
    
  const designerFiles = document.querySelectorAll('.js-designer-file');
  const designerImages = document.querySelectorAll('.js-brand-image');

  designerFiles.forEach((file) => {
    file.addEventListener('mouseenter', (event) => {
      const fileEl = event.target;
      const fileId = fileEl.dataset.id;
      designerImages.forEach((image) => {
        if (image.id == fileId) {
          image.classList.remove('hidden');
        } else {
          image.classList.add('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-designer-arrivals"] && !Shopify.designMode) return;
  try {
    
  function loadScript(src, callback) {
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = callback;
    document.body.appendChild(script);
  }

  const sliderContainer = document.querySelector('.new-arrivals-slider');
  const swiperUrl = sliderContainer.dataset.swiperJs;

  document.addEventListener('DOMContentLoaded', function () {
    loadScript(swiperUrl, function () {
      if (typeof Swiper !== 'undefined') {
        new Swiper(sliderContainer, {
          slidesPerView: 2.1,
          spaceBetween: 8,
          initialSlide: 0,
          breakpoints: {
            990: {
              slidesPerView: 4,
            },
            1280: {
              slidesPerView: 6,
              spaceBetween: 16,
            },
          },
          mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
            sensitivity: 5,
          },
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  function validateForm(formId, rules) {
    const form = document.getElementById(formId);
    console.log(form);
    if (!form) {
      console.error(`Form with ID "${formId}" not found.`);
      return;
    }

    function validateField(input, rule) {
      const value = input.value.trim();
      let isValid = true;

      if (rule.required && !value) {
        isValid = false;
      }

      if (rule.type === 'email' && value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        isValid = emailRegex.test(value);
      }

      return isValid;
    }

    function applyValidation(input, rule, fromSubmit = false) {
      const isValid = validateField(input, rule);

      if (fromSubmit || input.value.trim() !== '') {
        input.classList.toggle('invalid', !isValid);
      } else {
        input.classList.remove('invalid');
      }

      return isValid;
    }

    function isReadyForSubmit() {
      let allValid = true;

      Object.keys(rules).forEach((selector) => {
        const input = form.querySelector(selector);
        if (input) {
          const isValid = applyValidation(input, rules[selector], true);
          if (!isValid) allValid = false;
        }
      });
      return allValid;
    }

    Object.keys(rules).forEach((selector) => {
      const input = form.querySelector(selector);
      if (input) {
        input.addEventListener('keyup', () => applyValidation(input, rules[selector]));
        input.addEventListener('blur', () => applyValidation(input, rules[selector]));
      }
    });

    form.addEventListener('submit', (e) => {
      if (!isReadyForSubmit()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    });
  }

  validateForm('ContactForm', {
    '#ContactForm-first_name': { required: true },
    '#ContactForm-last_name': { required: true },
    '#ContactForm-email': { required: true, type: "email" }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  function loadScript(src, callback) {
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = callback;
    document.body.appendChild(script);
  }

  const sliderContainer = document.querySelector('.js-featured-collection-slider');
  const swiperUrl = sliderContainer.dataset.swiperJs;

  document.addEventListener('DOMContentLoaded', function () {
    loadScript(swiperUrl, function () {
      if (typeof Swiper !== 'undefined') {
        new Swiper(sliderContainer, {
            slidesPerView: 2.1,
            spaceBetween: 8,
            initialSlide: 0,
            breakpoints: {
                768: {
                    slidesPerView: 2.1
                },
                1024: {
                    slidesPerView: 3.1,
                    spaceBetween: 16
                },
                1280: {
                    slidesPerView: 4.1,
                    spaceBetween: 16
                },
            },
            mousewheel: {
              enabled: true,
              releaseOnEdges: true,
              forceToAxis: true,
              sensitivity: 5,
          },
        })
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-colors"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".featured-color__name");
  const tabContents = document.querySelectorAll(".color-group");

  tabButtons.forEach(button => {
    button.addEventListener("mouseover", function () {
      const targetTab = this.getAttribute("data-tab");

      // Remove active class from all buttons
      tabButtons.forEach(btn => btn.classList.remove("active"));

      // Hide all content
      tabContents.forEach(content => content.classList.add("hidden"));

      // Show the matched content and add active class to button
      document.getElementById(targetTab)?.classList.remove("hidden");
      this.classList.add("active");
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    if(window.innerWidth < 1024 ) {
      document.querySelectorAll(".footer-block__header").forEach((header) => {
        const block = header.closest(".footer-block");
        const body = block.querySelector(".footer-block__body");
        const button = block.querySelector(".footer-block__arrow");
  
        if (body) {
          header.addEventListener("click", function () {
            const isExpanded = body.style.display === "block";
            document.querySelectorAll(".footer-block__body").forEach((el) => {
              el.style.display = "none";
            });
            document.querySelectorAll(".footer-block__arrow").forEach((btn) => {
              btn.setAttribute("aria-expanded", "false");
            });
            body.style.display = isExpanded ? "none" : "block";
            button.setAttribute("aria-expanded", !isExpanded);
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      
      this.createObserver();
      this.toggleMegaMenu();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--scroll-width', `${this.getScrollbarWidth()}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > 0) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    getScrollbarWidth () {
      return window.innerWidth - document.documentElement.clientWidth;
    }

    toggleMegaMenu() {
        if (window.innerWidth < 1024) return;
        const menuLinks = document.querySelectorAll('.mega-menu__item');

        menuLinks.forEach(link => {
          link.addEventListener('mouseenter', () => {
            document.body.classList.add('open-shop')
            document.documentElement.classList.add('no-scroll')
          })

          link.addEventListener('mouseleave', () => {
            document.body.classList.remove('open-shop')
            document.documentElement.classList.remove('no-scroll')
          })
        })
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  const TABHASHID = ['#info', '#history', '#addresses']

  const orderContainer = document.querySelector('.js-order-container');
  if (orderContainer) {
    const orderList = orderContainer.querySelector('.orders');
    const orders = orderContainer.querySelectorAll('.order-details')
    
  
    orderContainer.addEventListener('click', event => {
      if (isElement(event, 'js-order-view')) {
        const orderId = event.target.dataset.order;
        ViewOrderById(orderId);
      }
  
      if( isElement(event, 'js-order-close') ) {
        orderList.classList.remove('hidden')
        orders.forEach(order => {
          order.classList.add('hidden');
        });
      }
  
    })
    
    function ViewOrderById(id) {
      const getOrderById = document.querySelector(`#${id}`);
      getOrderById.classList.remove('hidden');
      orderList.classList.add('hidden');
      window.scrollTo(0,0)
    }
  
    function isElement(event, targetElementClasss) {
      return event.target.classList.contains(targetElementClasss)
    }
  }


  const tabLinkContainer = document.querySelector('.side-nav');
  const tabLinkParentItems = tabLinkContainer.querySelectorAll('.side-nav__item');
  const tabContents = document.querySelectorAll('.customer__content-row')

  tabLinkContainer.addEventListener('click', toggleTab)

  function toggleTab(event) {
    if(isElement(event, 'side-nav__link')) {
      event.preventDefault();
      const selectedTabEl = event.target;
      const tabId = selectedTabEl.hash
      const selectedTabParentElement = selectedTabEl.parentElement;
      const targetTabElement = document.querySelector(tabId);
      setActiveTabLink(selectedTabParentElement, tabLinkParentItems, 'active')
      setActiveTabContent(targetTabElement, tabContents, 'hidden');

      replaceWindowHash(tabId);

    }
  }

  function setActiveTabLink(targetTabElement, elements, classes) {
    elements.forEach(items => {
        items.classList.remove(classes);
        targetTabElement.classList.add(classes);
    });
  }

  function setActiveTabContent(targetTabElement, elements, classes) {
    elements.forEach(items => {
        items.classList.add(classes);
        targetTabElement.classList.remove(classes);
    });
  }

  function replaceWindowHash(hash) {
    const urlHash = window.location.hash;
    const urlWithHash = urlHash ? window.location.href.replace(urlHash, hash) : `${ window.location.href}${hash}`;
    window.history.replaceState(null, null, urlWithHash);
  }

  function initializeCustomerTab() {
    const tabId = window.location.hash;
    if( tabId && TABHASHID.includes(tabId) ) {
      const getTabContentById = document.querySelector(tabId);
      const getTabLinkByHash = document.querySelector([`[href="${tabId}"]`]).parentElement;
      setActiveTabLink(getTabLinkByHash, tabLinkParentItems, 'active')
      setActiveTabContent(getTabContentById, tabContents, 'hidden');
    }
  }

  initializeCustomerTab();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  function loadScript(src, callback) {
			var script = document.createElement('script');
			script.src = src;
			script.defer = true;
			script.onload = callback;
			document.body.appendChild(script);
		}
	
		document.addEventListener('DOMContentLoaded', function () {
      const sliderContainer = document.querySelector('#slider-container').dataset.sliderJs;
			loadScript(sliderContainer, function () {
				if (typeof Splide !== 'undefined') {
					new Splide('#collection-slider', {
						autoWidth: true,
						gap: '1.5rem',
						pagination: false,
						arrows: false,
					}).mount();
				}
			});
		});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  function validateForm(formId, rules) {
    const form = document.getElementById(formId);
    if (!form) {
      console.error(`Form with ID "${formId}" not found.`);
      return;
    }

    function validateField(input, rule) {
      const value = input.value.trim();
      let isValid = true;

      // Required validation
      if (rule.required && !value) {
        isValid = false;
      }

      // Email validation
      if (rule.type === 'email' && value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        isValid = emailRegex.test(value);
      }

      return isValid;
    }

    function applyValidation(input, rule, fromSubmit = false) {
      const isValid = validateField(input, rule);

      if (fromSubmit || input.value.trim() !== '') {
        input.classList.toggle('invalid', !isValid);
      } else {
        input.classList.remove('invalid');
      }

      return isValid;
    }

    function isReadyForSubmit() {
      let allValid = true;

      Object.keys(rules).forEach((selector) => {
        const input = form.querySelector(selector);
        if (input) {
          const isValid = applyValidation(input, rules[selector], true);
          if (!isValid) allValid = false;
        }
      });
      return allValid;
    }

    // Attach event listeners for real-time validation
    Object.keys(rules).forEach((selector) => {
      const input = form.querySelector(selector);
      if (input) {
        input.addEventListener('keyup', () => {
          input.classList.remove('invalid');
        });
        input.addEventListener('blur', () => applyValidation(input, rules[selector]));
      }
    });

    form.addEventListener('submit', (e) => {
      if (!isReadyForSubmit()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    });
  }

  validateForm('customer_login', {
    '[type="email"]': { required: true, type: 'email' },
    '[type="password"]': { required: true },
  });

  validateForm('recover-form', {
    '[type="email"]': { required: true, type: 'email' },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
   
    // Get all tab header links and content elements
    const tabLinks = document.querySelectorAll('.product-tab__header a');
    const tabContents = document.querySelectorAll('.product-tab__content');

    if( tabLinks && tabContents) {
      // Function to hide all tab contents
      function hideAllTabContents() {
        tabContents.forEach(content => {
          content.style.display = 'none';
        });
      }
    
      // Function to remove active class from all tab links
      function removeActiveFromTabLinks() {
        tabLinks.forEach(link => link.classList.remove('active'));
      }
    
      // Attach click event listener to each tab link
      tabLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const targetId = this.getAttribute('href');
          hideAllTabContents();
          removeActiveFromTabLinks();

          if(targetId == '#') return;
          
          const targetContent = document.querySelector(targetId);
          if (targetContent) {
            targetContent.style.display = 'block';
          }
          this.classList.add('active');
        });
      });
      if (tabLinks.length > 0) {
        tabLinks[0].click();
      }
    }
  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  function validateForm(formId, rules) {
    const form = document.getElementById(formId);
    if (!form) {
      console.error(`Form with ID "${formId}" not found.`);
      return;
    }

    function validateField(input, rule) {
      const value = input.value.trim();
      let isValid = true;

      // Required validation
      if (rule.required && !value) {
        isValid = false;
      }

      // Email validation
      if (rule.type === 'email' && value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        isValid = emailRegex.test(value);
      }

      return isValid;
    }

    function applyValidation(input, rule, fromSubmit = false) {
      const isValid = validateField(input, rule);

      if (fromSubmit || input.value.trim() !== '') {
        input.classList.toggle('invalid', !isValid);
      } else {
        input.classList.remove('invalid');
      }

      return isValid;
    }

    function isReadyForSubmit() {
      let allValid = true;

      Object.keys(rules).forEach((selector) => {
        const input = form.querySelector(selector);
        if (input) {
          const isValid = applyValidation(input, rules[selector], true);
          if (!isValid) allValid = false;
        }
      });
      return allValid;
    }

    // Attach event listeners for real-time validation
    Object.keys(rules).forEach((selector) => {
      const input = form.querySelector(selector);
      if (input) {
        input.addEventListener('keyup', () => {
          input.classList.remove('invalid');
        });
        input.addEventListener('blur', () => applyValidation(input, rules[selector]));
      }
    });

    form.addEventListener('submit', (e) => {
      if (!isReadyForSubmit()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    });
  }

  validateForm('create_customer', {
    '[type="email"]': { required: true, type: 'email' },
    '[type="password"]': { required: true },
    '[name="customer[first_name]"]': { required: true},
    '[name="customer[last_name]"]': { required: true},
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-about-designer"] && !Shopify.designMode) return;
  try {
    
  const designerFiles = document.querySelectorAll('.js-designer-file');
  const designerImages = document.querySelectorAll('.js-brand-image');

  designerFiles.forEach((file) => {
    file.addEventListener('mouseenter', (event) => {
      const fileEl = event.target;
      const fileId = fileEl.dataset.id;
      designerImages.forEach((image) => {
        if (image.id == fileId) {
          image.classList.remove('hidden');
        } else {
          image.classList.add('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-about-mission"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    let mm = gsap.matchMedia();
    function getElementTopPosition(element) {
      // Get the element's bounding rectangle
      const rect = element.getBoundingClientRect();
      const yOffset = document.querySelector('.about-mission__content').offsetTop;
      
      // Return the top position relative to the top of the document
      return  yOffset;
    }

    mm.add('(min-width: 992px)', ()=> {
      const rows = gsap.utils.toArray('.about-mission__label');
      rows.forEach((row, i) => {
        gsap.to(row, {
          scrollTrigger: {
            trigger: row,
            start: ()=> `top top+=${i * 20 + 70}px`,
            end: 'top 40%',
            endTrigger: '.end-trigger',
            pin: true,
            pinSpacer: false,
            pinSpacing: false,
            scrub: 1
          }
        })
      })

      const btns = document.querySelectorAll('.about-mission__label');
      const rowHeight  = document.querySelector('.about-mission__content .row').clientHeight;
      btns.forEach((btn, i) => {
        btn.addEventListener('click', function(){
          const parent = this.closest('.js-sticky');
          const target = getElementTopPosition(parent);
          gsap.to(window, {
            scrollTo: { y: target + i * rowHeight  },
          })
        })
      })
    })

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-designer"] && !Shopify.designMode) return;
  try {
    
  function loadScript(src, callback) {
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = callback;
    document.body.appendChild(script);
  }

  const sliderContainer = document.querySelector('.js-designer-collection-slider');
  const swiperUrl = sliderContainer.dataset.swiperJs;

  document.addEventListener('DOMContentLoaded', function () {
    loadScript(swiperUrl, function () {
      if (typeof Swiper !== 'undefined') {
        new Swiper(sliderContainer, {
            slidesPerView: 2.1,
            spaceBetween: 8,
            initialSlide: 0,
            breakpoints: {
                768: {
                    slidesPerView: 2.1
                },
                1024: {
                    slidesPerView: 3.1,
                    spaceBetween: 16
                },
                1280: {
                    slidesPerView: 4.1,
                    spaceBetween: 16
                },
            },
            mousewheel: {
              enabled: true,
              releaseOnEdges: true,
              forceToAxis: true,
              sensitivity: 5,
          },
        })
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".js-video-play");
  const videoDesktop = document.querySelector(".js-video");
  const videoMobile = document.querySelector(".js-mobile-video");

  if (!button || !videoDesktop || !videoMobile) return;

  button.addEventListener("click", function () {
    const isMobileDevice = window.innerWidth <= 768;

    const primaryVideo = isMobileDevice ? videoMobile : videoDesktop;
    const secondaryVideo = isMobileDevice ? videoDesktop : videoMobile;

    primaryVideo.muted = false;
    primaryVideo.removeAttribute("muted");
    primaryVideo.setAttribute("controls", true);
    primaryVideo.volume = 1;
    primaryVideo.play();
    secondaryVideo.pause();

    button.classList.add("hidden");
  });
});


  } catch(e) { console.error(e); }
})();
})();
